/**
 * @param customer，从js-sdk中获取的用户信息
 * 为http请求拼接header
 */
function createApiHeader (axios, customer) {
  let header = {
    'x-yhsd-cid': '',
    'x-yhsd-ctime': ''
  }
  header['x-yhsd-cid'] = customer.id
  header['x-yhsd-ctime'] = customer.regist_at
  axios.defaults.headers = Object.assign(axios.defaults.headers, header)
}

export {createApiHeader}



// WEBPACK FOOTER //
// ./src/api/createApiHeader.js